<template>
    <label :for="context.id">
        <span
            class="text-12 text-text tracking-normal"
            v-if="context.label === 'signUp'"
        >
            <span class="text-text_light opacity-60">{{
                $t("By signing up, you agree to the")
            }}</span>
            <router-link
                class="underline"
                :to="{ path: '/terms-of-service' }"
                >{{ $t("Terms of Service") }}</router-link
            >
            <span class="text-text_light opacity-60">{{ $t("and") }}</span>
            <router-link class="underline" :to="{ path: '/privacy-policy' }">{{
                $t("Privacy Policy")
            }}</router-link>
        </span>
        <span v-else class="text-12 text-text opacity-60 tracking-normal">{{
            context.label
        }}</span>
    </label>
</template>

<script>
export default {
    name: "SignUpCheckboxLabel",

    props: {
        context: {
            type: Object,
            required: true
        }
    }
};
</script>
